import AuthCode from "react-auth-code-input";
import AuthStyle from "../../style/components/RegisterSteps/Step2OtpVerify.module.css";
import MainStyle from "../../style/Main.module.css";
import Loader from "../ui/Loader/Loader";
const Step2AccountDetails = ({
  formData,
  onChange,
  errors,
  resendCooldown,
  handleResendOTP,
  isResending,
  canResend,
}) => {
  return (
    <div>
      <p className={AuthStyle.otpPageParagraph}>
        You have received a One-Time Password (OTP) on your registered email
        address.{" "}
      </p>
      <AuthCode
        value={formData?.otp || ""}
        onChange={(otp) => onChange({ target: { name: "otp", value: otp } })}
        allowedCharacters="numeric"
        length={5}
        containerClassName={AuthStyle.otpBoxClass}
        inputClassName={AuthStyle.authInputOtp}
      />
      {errors.otp && (
        <div className={MainStyle.errorMsgCenter}>{errors.otp}</div>
      )}
      {errors.api && (
        <div className={MainStyle.errorMsgCenter}>{errors.api}</div>
      )}
      <div className={AuthStyle.resendContainer}>
        {!canResend ? (
          <p className={MainStyle.textAlignCenter}>
            Resend available in {resendCooldown?.minutes ?? 0}:
            {(resendCooldown?.seconds ?? 0).toString().padStart(2, "0")}
          </p>
        ) : (
          <p
            className={MainStyle.textAlignCenter}
            style={{
              color: "cornflowerblue",
              cursor: isResending ? "default" : "pointer",
              pointerEvents: isResending ? "none" : "auto",
            }}
            onClick={handleResendOTP}
          >
            {isResending ? (
              <div>
                <Loader color="#3b82f6" />
              </div>
            ) : (
              "Resend"
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default Step2AccountDetails;
